import React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

//service item
class Service_Item extends React.Component {
  render() {
    return (
      <div className="service-item">
        <div className="container">
          <div className="service service-teaser">
            <div className="service-content">
              <div className="bg-text">{this.props.bgtitle}​​​​​​​​</div>
              <label>Services</label>
              <h2>{this.props.title}​​​​​​​​</h2>
              <p>{this.props.excerpt}​​​​​​​​</p>
              <Link className="btn btn-primary" to={this.props.path}>
                Find out more
              </Link>
            </div>
            <div className="service-img">
              <img className="img-fluid" alt="service" src={this.props.image} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Service_Item;
